import { render, staticRenderFns } from "./GroupListSelectionView.vue?vue&type=template&id=1656a59b&scoped=true&"
import script from "./GroupListSelectionView.vue?vue&type=script&lang=ts&"
export * from "./GroupListSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListSelectionView.vue?vue&type=style&index=0&id=1656a59b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1656a59b",
  null
  
)

export default component.exports